import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Profile.css';
import { CiPhone } from "react-icons/ci";
import { MdOutlineEmail } from "react-icons/md";
import { IoIosPerson } from "react-icons/io";
import { IoLogOutOutline } from "react-icons/io5";
import { RiContactsLine } from "react-icons/ri";
import { FaUserShield } from "react-icons/fa";
import { GiReceiveMoney } from "react-icons/gi";
import { MdLockReset } from "react-icons/md";
import { useAuth } from '../api/Authcontext';
import PageTitle from '../components/UI/PageTitle';

const Profile = () => {
  const navigate = useNavigate();
  const { userData, logout, isLoading: authLoading } = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  // Set loading based on auth state
  useEffect(() => {
    if (!authLoading) {
      setIsLoading(false);
    }
  }, [authLoading]);

  const handleLogout = async () => {
    try {
      const confirmLogout = window.confirm('Are you sure you want to logout?');
      if (!confirmLogout) return;

      setIsLoading(true);
      await logout();
      navigate('/');
    } catch (error) {
      alert('Failed to log out. Please try again.');
      console.error('Logout error:', error);
      setIsLoading(false);
    }
  };


  const profileSections = [
    { 
      icon: <MdOutlineEmail color='#007800'/>, 
      label: 'Email', 
      value: userData?.email || 'Not available' 
    },
    { 
      icon: <CiPhone color='#007800'/>, 
      label: 'Phone', 
      value: userData?.phone || 'Not available' 
    },
    { 
      icon: <IoIosPerson color='#007800'/>, 
      label: 'Role', 
      value: userData?.role || 'Not available' 
    },
    { 
      icon: <RiContactsLine color='#007800'/>, 
      label: 'Emergency Contact', 
      value: userData?.emergencyContact?.name ? 
        `${userData.emergencyContact.name}` : 
        'Not available' 
    },
    { 
      icon: <CiPhone color='#007800'/>, 
      label: 'Emergency Contact Phone', 
      value: userData?.emergencyContact?.name ? 
        `${userData.emergencyContact.contact}` : 
        'Not available' 
    },
    { 
      icon: <FaUserShield color='#007800'/>, 
      label: 'Beneficiary', 
      value: userData?.beneficiary?.name ? 
        `${userData.beneficiary.name}` : 
        'Not available' 
    },
    
    { 
      icon: <CiPhone color='#007800'/>, 
      label: 'Beneficiary Phone', 
      value: userData?.beneficiary?.name ? 
        `${userData.beneficiary.contact}` : 
        'Not available' 
    },
    { 
      icon: <GiReceiveMoney color='#007800'/>, 
      label: 'Legacy Credits', 
      value: userData?.currentLegacyCredits !== undefined ? 
        userData.currentLegacyCredits.toString() : 
        'Not available' 
    }
  ];

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p className="loading-text">Loading profile...</p>
      </div>
    );
  }

  return (
    <div className="profile-container">
      <PageTitle title="Profile" />
      <div className="profile-scroll">
        <div className="profile-content">
          <div className="avatar-container">
            {userData?.name ? (
              <div className="avatar">
                <span className="avatar-text">
                  {userData.name.split(' ').map(n => n[0]).join('').toUpperCase()}
                </span>
              </div>
            ) : (
              <div className="avatar">
                <span className="avatar-icon">👤</span>
              </div>
            )}
          </div>
          
          <h1 className="user-name">{userData?.name || 'User'}</h1>
          
          <div className="divider"></div>
          
          <div className="info-container">
            {profileSections.map((section, index) => (
              <div key={index} className="info-row">
                <div className="info-icon-container">
                  <span className="info-icon">{section.icon}</span>
                </div>
                <div className="info-text-container">
                  <p className="info-label">{section.label}</p>
                  <p className="info-value">{section.value}</p>
                </div>
              </div>
            ))}
          </div>
          
          <button 
            className="change-password-button" 
            onClick={() => navigate('/change-password')}
          >
            <span className="change-password-icon"><MdLockReset /></span>
            <span className="change-password-text">Change Password</span>
          </button>
          
          <button 
            className="logout-button" 
            onClick={handleLogout}
          >
            <span className="logout-icon"><IoLogOutOutline /></span>
            <span className="logout-text">Logout</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile;